import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import "../styles/CheckCertificatesStyles.css";
import CertificateIcon from "../../../assets/images/certificates/certificate.png";

const CheckCertificates: React.FC = () => {
  const navigate = useNavigate();

  const profileData = useSelector(
    (state: RootState) => state.profile.profileKeys,
  );

  const instituteName = profileData?.institute_name || "";
  const candidateId = profileData?.candidate_id || "";

  const handleIconClick = () => {
    navigate("/dashboard/certificates");
  };

  // Specific candidate ID that should see the certificate icon
  const allowedCandidateId = "649fd11b-e783-412d-8f33-093f4abac72a";

  // Show certificate icon for TechBots Academy OR the specific candidate
  const shouldShowIcon =
    instituteName === "TechBots Academy" || candidateId === allowedCandidateId;

  if (!shouldShowIcon) {
    return null;
  }

  return (
    <div className="certificates-icon" onClick={handleIconClick}>
      <img
        src={CertificateIcon}
        alt="Certificates"
        className="certificates-icon-image"
      />
      <span className="certificates-tooltip">Check your Certificates</span>
    </div>
  );
};

export default CheckCertificates;
